import { useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { isMobile } from "react-device-detect";
import { ReactComponent as IconInfo } from "../assets/images/info.svg";
import { ReactComponent as TitleCrystalMap } from "../assets/images/crystal-map.svg";

const transition = {
  duration: 0.666,
};

const variants = {
  show: {
    opacity: 1,
    transition,
  },
  hide: {
    opacity: 0,
    transition,
  },
};

const Info = () => {
  const frame = useRef();
  const [rotation, setRotation] = useState(0);
  const [showInfo, setShowInfo] = useState(false);

  const handleOnMouseEnter = () => {
    setRotation((i) => i + 4);
    frame.current = requestAnimationFrame(handleOnMouseEnter);
  };
  const handleOnMouseLeave = () => cancelAnimationFrame(frame.current);
  const mouseOverProps = {
    style: { transform: `rotate(-${rotation}deg)` },
    onMouseEnter: handleOnMouseEnter,
    onMouseLeave: handleOnMouseLeave,
  };

  return (
    <>
      <button
        className="info-toggle"
        onClick={() => setShowInfo((state) => !state)}
        {...(!isMobile ? mouseOverProps : {})}
      >
        <IconInfo />
      </button>
      <AnimatePresence>
        {showInfo && (
          <motion.div
            variants={variants}
            initial="hide"
            animate="show"
            exit="hide"
            className="info-overlay"
          >
            <div className="info-overlay__content">
              <div className="info-overlay__title">
                <TitleCrystalMap />
              </div>
              <h2>Crystal map</h2>
              <p>
                Volcano is a universal symbol of inner growth and awareness
                through a slow traumatic cycle of continuous transformation. To
                gain a sense of how the human body was formed over millions of
                years through successive generations of an evolutionary chain,
                pay a visit to an active volcano as it slowly unfurls a new
                additional lumpy shape to the visible body of the world as part
                of our planet's ongoing geological and meteorological
                revolutions.
              </p>
              <h2>Contact</h2>
              <p>
                <a href="mailto:jannetemark@gmail.com">jannetemark@gmail.com</a>
              </p>
              <h2>Colophon</h2>
              <p>
                Initiated &amp; designed by{" "}
                <a href="https://jannetemark.com/">Jannete Mark</a> <br />
                Programming by{" "}
                <a href="https://berndderidder.nl/">Bernd de Ridder</a> <br />
                With support of{" "}
                <a href="https://www.werkplaatstypografie.org/">
                  Werkplaats Typografie
                </a>
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Info;
